import { Injectable, Output, EventEmitter } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";
/*import { IAssetStatus, IDocumentView, IUserTraining } from "src/app/models";*/
import { RoutingService } from "src/app/services";
import { lastValueFrom } from "rxjs";
import { Helpers } from "../helpers";

@Injectable({
  providedIn: 'root'
})
export class DiscussionService {
  private Discussion_URL = environment.discussionService.url + environment.discussionService.apiVersion;

  constructor(private http: HttpClient, private routeService: RoutingService) { }

  getTopicPostTip(postId: number) {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.get<any>(`${this.Discussion_URL}Discussion/GetTopicPostTip/${postId}`))
        .then((result: any) => {
          resolve(result);
        }, (err) => {
          reject(err);
        });
    });
  }

  getUserForumPermissions(userId: number, portalId: number, portalRoleId: number, forumId: number) {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.get<any>(`${this.Discussion_URL}Discussion/GetUserForumPermissions/${userId}/${portalId}/${<number>Helpers.getPlatformId()}/${portalRoleId}/${forumId}`))
        .then((result: any) => {
          resolve(result);
        }, (err) => {
          reject(err);
        });
    });
  }

  getModerators(portalId: number) {
    return new Promise<Array<any>>((resolve, reject) => {
      lastValueFrom(this.http.get<any>(`${this.Discussion_URL}Discussion/GetModerators/${portalId}/${<number>Helpers.getPlatformId()}`))
        .then((forms: Array<any>) => {
          resolve(forms);
        }, (err) => {
          reject(err);
        });
    });
  }

  getGetForumsForDashboard(userId: number, portalId: number, roleId: number) {
    return new Promise<Array<any>>((resolve, reject) => {
      lastValueFrom(this.http.get<any>(`${this.Discussion_URL}Discussion/GetForumsForDashboard/${userId}/${portalId}/${roleId}/${<number>Helpers.getPlatformId()}`))
        .then((forms: Array<any>) => {
          resolve(forms);
        }, (err) => {
          reject(err);
        });
    });
  }

  getForumTopicsPaged(userId: number, portalId: number, portalRoleId: number, forumId: number, pageSize: number, pageIndex: number) {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.get<any>(`${this.Discussion_URL}Discussion/GetForumTopicsPaged/${userId}/${portalId}/${<number>Helpers.getPlatformId()}/${portalRoleId}/${forumId}/${pageSize}/${pageIndex}`))
        .then((result: any) => {
          console.log('Forum Topics API Response:', result);
          resolve(result);
        }, (err) => {
          reject(err);
        });
    });
  }

  updateTopicTitle(userId: number, portalId: number, portalRoleId: number, topicId: number, title: string) {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.post<any>(`${this.Discussion_URL}Discussion/UpdateTopicTitle`, {
        UserID: userId,
        PortalID: portalId,
        PlatformID: <number>Helpers.getPlatformId(),
        PortalRoleID: portalRoleId,
        TopicID: topicId,
        Title: title
      }))
        .then((result: any) => {
          resolve(result);
        }, (err) => {
          reject(err);
        });
    });
  }

  getUserForumSubscriptions(userId: number, portalId: number, platformId: number) {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.get<any>(`${this.Discussion_URL}Discussion/GetUserForumSubscriptions/${userId}/${portalId}/${platformId}`))
        .then((result: any) => {
          resolve(result);
        }, (err) => {
          reject(err);
        });
    });
  }

  getUserTopicSubscriptions(userId: number, portalId: number, platformId: number) {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.get<any>(`${this.Discussion_URL}Discussion/GetUserTopicSubscriptions/${userId}/${portalId}/${platformId}`))
        .then((result: any) => {
          resolve(result);
        }, (err) => {
          reject(err);
        });
    });
  }

  forumSubscription(userId: number, portalId: number, forumIds: number[], subscribeType: number) {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.post<any>(`${this.Discussion_URL}Discussion/ForumSubscription`, {
        UserID: userId,
        PortalID: portalId,
        PlatformID: <number>Helpers.getPlatformId(),
        ForumIDs: forumIds,
        SubscribeType: subscribeType
      }))
        .then((result: any) => {
          resolve(result);
        }, (err) => {
          reject(err);
        });
    });
  }

  topicSubscription(userId: number, portalId: number, topicIds: number[], subscribeType: number) {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.post<any>(`${this.Discussion_URL}Discussion/TopicSubscription`, {
        UserID: userId,
        PortalID: portalId,
        PlatformID: <number>Helpers.getPlatformId(),
        TopicIDs: topicIds,
        SubscribeType: subscribeType
      }))
        .then((result: any) => {
          resolve(result);
        }, (err) => {
          reject(err);
        });
    });
  }

  getForumGroups(userId: number, portalId: number, portalRoleId: number, forumId: number) {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.get<any>(`${this.Discussion_URL}Discussion/GetForumGroups/${userId}/${portalId}/${portalRoleId}/${<number>Helpers.getPlatformId()}/${forumId}`))
        .then((result: any) => {
          resolve(result);
        }, (err) => {
          reject(err);
        });
    });
  }

  getModerationTopics(userId: number, portalId: number, platformId: number, portalRoleId: number, moderationType: number, pageIndex: number, pageSize: number) {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.get<any>(`${this.Discussion_URL}Discussion/GetModerationTopics/${userId}/${portalId}/${platformId}/${portalRoleId}/${moderationType}/${pageIndex}/${pageSize}`))
        .then((result: any) => {
          resolve(result);
        }, (err) => {
          reject(err);
        });
    });
  }

  moderateTopic(userId: number, portalId: number, platformId: number, portalRoleId: number, postId: number, action: number) {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.post<any>(`${this.Discussion_URL}Discussion/ModerateTopic`, {
        UserID: userId,
        PortalID: portalId,
        PlatformID: platformId,
        PortalRoleID: portalRoleId,
        PostID: postId,
        Action: action
      }))
        .then((result: any) => {
          resolve(result);
        }, (err) => {
          reject(err);
        });
    });
  }

  postTopic(userId: number, portalId: number, portalRoleId: number, forumId: number, title: string, message: string, isPoll: boolean = false, subscribeToTopic: boolean = false, files: File[] = []): Promise<any> {
    const formData = new FormData();
    formData.append('UserID', userId.toString());
    formData.append('PortalID', portalId.toString());
    formData.append('PlatformID', (<number>Helpers.getPlatformId()).toString());
    formData.append('PortalRoleID', portalRoleId.toString());
    formData.append('ForumID', forumId.toString());
    formData.append('Title', title);
    formData.append('TitleEncoded', encodeURIComponent(title));
    formData.append('Description', title);
    formData.append('Message', message);
    formData.append('IsPoll', isPoll.toString());
    formData.append('SubscribeToTopic', subscribeToTopic.toString());
    for (const file of files) {
      formData.append('files', file, file.name);
    }
    return lastValueFrom(this.http.post<any>(`${this.Discussion_URL}Discussion/PostTopic`, formData));
  }


  postPollTopic(userId: number, portalId: number, portalRoleId: number, forumId: number, pollQuestion: string, pollMessage: string, multipleChoice: boolean, pollAnswers: string[], files: File[] = []): Promise<any> {
    const formData = new FormData();
    formData.append('UserID', userId.toString());
    formData.append('PortalID', portalId.toString());
    formData.append('PlatformID', (<number>Helpers.getPlatformId()).toString());
    formData.append('PortalRoleID', portalRoleId.toString());
    formData.append('ForumID', forumId.toString());
    formData.append('Title', pollQuestion);
    formData.append('TitleEncoded', encodeURIComponent(pollQuestion));
    formData.append('Description', pollQuestion);
    formData.append('Message', pollMessage);
    formData.append('QuestionText', pollQuestion);
    formData.append('MultipleChoice', multipleChoice.toString());
    formData.append('SubscribeToTopic', 'true');
    
    // Add poll answers as JSON string
    formData.append('AnswersJson', JSON.stringify(pollAnswers));
    
    // Add files
    for (const file of files) {
      formData.append('files', file, file.name);
    }
    
    return lastValueFrom(this.http.post<any>(`${this.Discussion_URL}Discussion/PostPollTopic`, formData));
  }

  getPoll(postId: number, userId: number, portalId: number, portalRoleId: number) {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.get<any>(`${this.Discussion_URL}Discussion/GetPoll/${postId}/${userId}/${portalId}/${portalRoleId}/${<number>Helpers.getPlatformId()}`))
        .then((result: any) => {
          resolve(result);
        }, (err) => {
          reject(err);
        });
    });
  }

  submitPollVote(postId: number, userId: number, pollAnswerIDs: number[]) {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.post<any>(`${this.Discussion_URL}Discussion/SubmitPollVote`, {
        PostID: postId,
        UserID: userId,
        PollAnswerIDs: pollAnswerIDs
      }))
        .then((result: any) => {
          resolve(result);
        }, (err) => {
          reject(err);
        });
    });
  }

  getTopicPosts(userId: number, portalId: number, portalRoleId: number, topicId: number, pageIndex: number, pageSize: number, sortOrder: string = 'ASC', displayMode: number = 0) {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.get<any>(`${this.Discussion_URL}Discussion/GetTopicPosts/${userId}/${portalId}/${<number>Helpers.getPlatformId()}/${portalRoleId}/${topicId}/${pageSize}/${pageIndex}?SortOrder=${sortOrder}&DisplayMode=${displayMode}`))
        .then((result: any) => {
          resolve(result);
        }, (err) => {
          reject(err);
        });
    });
  }

  /**
   * Get moderator permissions for a specific forum
   * @param forumId - Forum ID to get moderator settings for
   * @returns Promise with moderator permissions from PortalForumsModeratorSetting table
   */
  getModeratorPermissions(forumId: number) {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.get<any>(`${this.Discussion_URL}Discussion/GetModeratorPermissions/${forumId}`))
        .then((result: any) => {
          resolve(result);
        }, (err) => {
          reject(err);
        });
    });
  }

  getAttachment(attachmentId: number, userId: number, portalId: number, portalRoleId: number): Promise<Blob> {
    return lastValueFrom(this.http.get(
      `${this.Discussion_URL}Discussion/GetAttachment/${attachmentId}/${userId}/${portalId}/${<number>Helpers.getPlatformId()}/${portalRoleId}`,
      { responseType: 'blob' }
    ));
  }

  postReply(userId: number, portalId: number, portalRoleId: number, forumId: number, topicId: number, parentId: number, message: string, files: File[] = [], title: string = '', titleEncoded: string = '', description: string = ''): Promise<any> {
    const formData = new FormData();
    formData.append('UserID', userId.toString());
    formData.append('PortalID', portalId.toString());
    formData.append('PlatformID', (<number>Helpers.getPlatformId()).toString());
    formData.append('PortalRoleID', portalRoleId.toString());
    formData.append('ForumID', forumId.toString());
    formData.append('TopicID', topicId.toString());
    formData.append('ParentID', parentId.toString());
    formData.append('Title', title);
    formData.append('TitleEncoded', titleEncoded);
    formData.append('Description', description);
    formData.append('Message', message);
    for (const file of files) {
      formData.append('files', file, file.name);
    }
    return lastValueFrom(this.http.post<any>(`${this.Discussion_URL}Discussion/PostReply`, formData));
  }

  // ✅ Updated: Now supports attachments and attachment deletion
  UpdateTopic(userId: number, portalId: number, portalRoleId: number, postId: number, message: string, title: string = '', files: File[] = [], deletedAttachmentIds: number[] = []) {
    const formData = new FormData();
    formData.append('UserID', userId.toString());
    formData.append('PortalID', portalId.toString());
    formData.append('PlatformID', (<number>Helpers.getPlatformId()).toString());
    formData.append('PortalRoleID', portalRoleId.toString());
    formData.append('PostID', postId.toString());
    formData.append('Title', title);
    formData.append('Message', message);
    
    // ✅ Add new file attachments
    for (const file of files) {
      formData.append('files', file, file.name);
    }
    
    // ✅ Add deleted attachment IDs
    for (const attachmentId of deletedAttachmentIds) {
      formData.append('deletedAttachmentIds', attachmentId.toString());
    }
    
    return lastValueFrom(this.http.post<any>(`${this.Discussion_URL}Discussion/UpdateTopic`, formData));
  }

  /// ✅ ATOMIC: Updates poll topic in single atomic transaction.
  /// Updates: topic message, poll question, poll answers, and attachments all together.
  /// If any step fails, entire transaction rolls back (no partial updates).
  editPollTopic(
    userId: number,
    portalId: number, 
    portalRoleId: number,
    pollId: number,
    topicId: number,
    questionText: string,
    multipleChoice: boolean,
    pollAnswers: string[],
    topicMessage: string,
    files: File[] = [],
    deletedAttachmentIds: number[] = []
  ): Promise<any> {
    const formData = new FormData();
    formData.append('UserID', userId.toString());
    formData.append('PortalID', portalId.toString());
    formData.append('PlatformID', (<number>Helpers.getPlatformId()).toString());
    formData.append('PortalRoleID', portalRoleId.toString());
    formData.append('PollID', pollId.toString());
    formData.append('TopicID', topicId.toString());
    formData.append('QuestionText', questionText);
    formData.append('MultipleChoice', multipleChoice.toString());
    formData.append('Message', topicMessage);
    
    // ✅ Add poll answers as JSON string (similar to PostPollTopic)
    formData.append('AnswersJson', JSON.stringify(pollAnswers));
    
    // ✅ Add deleted attachment IDs as JSON string
    formData.append('DeletedAttachmentIdsJson', JSON.stringify(deletedAttachmentIds));
    
    // ✅ Add new file attachments
    for (const file of files) {
      formData.append('files', file, file.name);
    }
    
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.post<any>(`${this.Discussion_URL}Discussion/UpdatePollTopic`, formData))
        .then((result: any) => {
          resolve(result);
        }, (err) => {
          reject(err);
        });
    });
  }

  /// <summary>
  /// @deprecated Use editPollTopic() instead. This method is maintained for backward compatibility.
  /// </summary>

  unsubscribeByGuid(userId: number, guid: string, type: string) {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.get<any>(`${this.Discussion_URL}Discussion/UnsubscribeByGuid/${userId}/${encodeURIComponent(guid)}/${encodeURIComponent(type)}`))
        .then((result: any) => {
          resolve(result);
        }, (err) => {
          reject(err);
        });
    });
  }

  searchForumTopics(request: {
    UserID: number,
    PortalID: number,
    PlatformID: number,
    PortalRoleID: number,
    ForumID: number,
    Keywords: string,
    SearchWithin: string,
    Filter: string,
    SortBy: string,
    SortOrder: string,
    PageIndex: number,
    PageSize: number
  }) {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.post<any>(`${this.Discussion_URL}Discussion/SearchForumTopics`, request))
        .then((result: any) => {
          resolve(result);
        }, (err) => {
          reject(err);
        });
    });
  }

  searchTopicPosts(request: {
    UserID: number,
    PortalID: number,
    PlatformID: number,
    PortalRoleID: number,
    TopicID: number,
    Keywords: string,
    PageIndex: number,
    PageSize: number,
    SortOrder: string
  }) {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.post<any>(`${this.Discussion_URL}Discussion/SearchTopicPosts`, request))
        .then((result: any) => {
          resolve(result);
        }, (err) => {
          reject(err);
        });
    });
  }

}
